import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
// redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/store";

// my imports
import useStyles from "../styles";
import {
  MeanType,
  setMeanType,
  toggleMultiLabel,
  setZerosRight,
  setZerosLeft,
} from "../redux/App.store";
import { tooltip_types_of_mean, tooltip_zeros_cut } from "../tooltips";

const AdvancedOptionsView = () => {
  const classes = useStyles();

  const meanType = useSelector((state: RootState) => state.app.meanType);
  const multiLabel = useSelector((state: RootState) => state.app.multiLabel);
  const zerosLeft = useSelector((state: RootState) => state.app.zerosLeft);
  const zerosRight = useSelector((state: RootState) => state.app.zerosRight);
  const dispatch = useDispatch();

  // functions

  // const handleSaveClicked = () => {
  // const options: controller.CommonOptions = {
  //   meanType: meanType === MeanType.geo ? 'geo' : 'ari',
  //   zerosLeft: zerosLeft,
  //   zerosRight: zerosRight,
  //   logScale: true,
  //   multiLabel: multiLabel,
  // };
  // controller.setConfig(options);
  // };

  return (
    <>
      <Grid item container>
        <Grid item container xs={12}>
          <Grid item>
            <Tooltip title={tooltip_types_of_mean}>
              <Typography variant="h6">Tipo de média:</Typography>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid item className={classes.typeDiaRadio}>
          <RadioGroup
            value={meanType === MeanType.geo ? "geo" : "ari"}
            row
            onChange={(e) =>
              dispatch(
                setMeanType(
                  e.target.value === "geo" ? MeanType.geo : MeanType.ari
                )
              )
            }
          >
            <FormControlLabel
              value="geo"
              control={<Radio color="primary" />}
              label="Geométrica"
              labelPlacement="end"
            />
            <FormControlLabel
              value="ari"
              control={<Radio color="primary" />}
              label="Aritimética"
              labelPlacement="end"
            />
          </RadioGroup>
        </Grid>
        <Grid item xs={12} className={classes.divider}>
          <Divider />
        </Grid>

        <Grid item xs>
          <FormControlLabel
            control={<Switch />}
            color="primary"
            label="Não colocar legendas nos gráficos de múltiplos arquivos"
            checked={!multiLabel}
            onChange={() => dispatch(toggleMultiLabel())}
          />
        </Grid>

        <Grid item xs={12} className={classes.divider}>
          <Divider />
        </Grid>

        <Grid item container spacing={1}>
          <Grid container item xs={12}>
            <Grid item>
              <Tooltip title={tooltip_zeros_cut}>
                <Typography variant="h6">Ignorar zeros:</Typography>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid container item className={classes.ZerosIgnore} spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Zeros à esquerda"
                type="number"
                required
                value={zerosLeft}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  const raw = Number(e.target.value);
                  const n = raw > 0 ? raw : 1;
                  dispatch(setZerosLeft(n));
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Zeros à direita"
                type="number"
                required
                value={zerosRight}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  const raw = Number(e.target.value);
                  const n = raw > 0 ? raw : 1;
                  dispatch(setZerosRight(n));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AdvancedOptionsView;
